export default __webpack_public_path__ + "static/Ayu Asmoro Ningrum-6bce04bf2eeb5f1538cc44d984e4b2d2.webp";